
// SCRIPTS

import { SecureHomePage } from './home/home.page'; export { SecureHomePage };
import { UserDirectoryPage } from './user-directory/user-directory.page'; export { UserDirectoryPage };
import { ProjectFormPage } from './project-form/scripts/project-form.page'; export { ProjectFormPage };
import { ProjectFormDashboardPage } from './project-form/scripts/project-form-dashboard.page'; export { ProjectFormDashboardPage };
import { WorkingGroupsPage } from './working-groups/scripts/working-groups.page'; export { WorkingGroupsPage };
import { ResourcesMembershipPage } from './collaboration/scripts/resources-membership.page'; export { ResourcesMembershipPage };

import { CppDashboardPage } from './cpp/cpp-dashboard/scripts/cpp-dashboard.page'; export { CppDashboardPage };
import { CppProposalFormPage } from './cpp/cpp-proposal-form/scripts/cpp-proposal-form.page'; export { CppProposalFormPage };
import { CabHubTrackingPage } from './cab-hub/cab-hub-tracking.page'; export { CabHubTrackingPage };
import { UpdateAccessPage } from '../auth/pages/access/update_access'; export { UpdateAccessPage };
import { CabHubConnectionDetailsPage } from './cab-hub/connection-details.page'; export {CabHubConnectionDetailsPage};
// STYLES
import './home/home.scss';
import './user-directory/user-directory.scss';
import './project-form/project-form.scss'
import './working-groups/working-groups.scss';
import './collaboration/resources-membership.scss';

import './cpp/cpp-dashboard/cpp-dashboard.scss';
import './cpp/cpp-proposal-form/cpp-proposal-form.scss';
import './cab-hub/cab-hub-tracking.scss';
import './cab-hub/connection-details.scss';
import './../auth/pages/access/update_access.scss';